import { Badge, Card, CardBody, CardTitle } from "reactstrap";
import { isTisaxFramework } from "src/modules/data-protection/helpers/Controls";
import doraIcon from "./icons/dora.png";
import isoIcon from "./icons/iso27001.png";
import tisaxIcon from "./icons/tisax.png";

const frameworkIconMap = {
  ISO27001: isoIcon,
  DORA: doraIcon,
  TISAX: tisaxIcon,
};

const baseBadgeStyle = {
  fontSize: 10,
  lineHeight: 1,
  padding: "4px 8px",
  borderRadius: 999,
  fontWeight: 600,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 54,
};



const FrameworkCoverageCardsSection = ({ t, dashboardData, frameworkLabelMap, selectedFramework }) => {
  const showMaturity = isTisaxFramework(selectedFramework);
  return (
    <Card className="card_box_Shadow h-100">
      <CardBody>
        <CardTitle>{t("Framework Coverage")}</CardTitle>
        <div className="mt-3 pt-1" style={{ overflowX: "auto", paddingBottom: 4 }}>
          <div className="d-flex gap-2" style={{ width: "100%" }}>
            {(dashboardData?.framework_cards || []).map((card) => (
              <Card
                key={card.framework}
                className="border"
                style={{ flex: "1 1 188px", minWidth: 160, borderColor: "#DDE0E4" }}
              >
                <CardBody className="py-2 px-2">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    {frameworkIconMap[card.framework] ? (
                      <img
                        src={frameworkIconMap[card.framework]}
                        alt={frameworkLabelMap[card.framework] || card.framework}
                        style={{ width: 28, height: 28, objectFit: "contain" }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          backgroundColor: "#E8F0FF",
                          color: "#3B5DA8",
                          fontSize: 11,
                          fontWeight: 700,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {(frameworkLabelMap[card.framework] || card.framework || "FW").slice(0, 2)}
                      </div>
                    )}
                    <div className="flex-grow-1">
                      <h6 className="mb-0">
                        {frameworkLabelMap[card.framework] || card.framework}
                      </h6>
                    </div>
                  </div>

                  <div className="mb-2">
                    {card.enabled ? (
                      <Badge
                        pill
                        style={{
                          ...baseBadgeStyle,
                          backgroundColor: "#0A8F58",
                          color: "#fff",
                        }}
                      >
                        {t("Enabled")}
                      </Badge>
                    ) : (
                      <Badge
                        pill
                        style={{
                          ...baseBadgeStyle,
                          backgroundColor: "#6C757D",
                          color: "#fff",
                        }}
                      >
                        {t("Disabled")}
                      </Badge>
                    )}
                  </div>

                  <p className="mb-2">
                    <span className="text-muted">{t("Total Controls")}</span>
                    <br />
                    <strong>{card.total_controls || 0}</strong>
                  </p>
                  <p className="mb-2">
                    <span className="text-muted">{t("Applicability")}</span>
                    <br />
                    <strong>{card.applicable_percent || 0}%</strong>
                  </p>
                  {showMaturity && card.framework === "TISAX" ? (
                    <p className="mb-2">
                      <span className="text-muted">{t("Maturity")}</span>
                      <br />
                      <strong>{card.avg_maturity_level || 0}</strong>
                    </p>
                  ) : null}
                  <p className="mb-0">
                    <span className="text-muted">{t("Mapping")}</span>
                    <br />
                    <strong>{card.mapping_completeness_percent || 0}%</strong>
                  </p>
                </CardBody>
              </Card>
            ))}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default FrameworkCoverageCardsSection;
